module.exports = __webpack_public_path__ + "img/login-img1.920f2caa.jpg";